import { render, staticRenderFns } from "./SemenCollectionAnimalEdit.vue?vue&type=template&id=2a9689c0&scoped=true&"
import script from "./SemenCollectionAnimalEdit.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionAnimalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9689c0",
  null
  
)

export default component.exports